import { DecisioningBatch } from "@app/app/interfaces/decisioning-batch.model";

export class GetBorrowerDecisioningForProduct {
  static readonly type = '[Decisioning] GetBorrowerDecisioningForProduct';
  constructor(
    public borrowerId: number,
    public loanProductId: number,
  ) {}

}
export class GetLenderDecisioningBatches {
  static readonly type = '[Decisioning] GetLenderDecisioningBatches';
  constructor(
    public lenderId: number,
  ) {}
}

export class SubscribeToDecisioningBatchPusherUpdates {
  static readonly type = '[Decisioning] SubscribeToDecisioningBatchPusherUpdates';
}

export class AddNewDecisioningProgress {
  static readonly type = '[Decisioning] AddNewDecisioningProgress';
  constructor(
    public decisioningBatch: DecisioningBatch,
  ) {}
}
export class UpdateDecisioningProgress {
  static readonly type = '[Decisioning] UpdateDecisioningProgress';
  constructor(
    public decisioningBatch: DecisioningBatch,
  ) {}
}
